<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {stringToColor} from "@/tscript/utils";
import {storeToRefs} from "pinia";
import {useMainStore} from "@/stores/mainStore";
import {User} from "@/lib/types";

interface AvatarPictureProps {
  firstName?: string;
  lastName?: string;
  pictureUrl?: string;
  size?: number;
  userId?: string;
}

const props = defineProps<AvatarPictureProps>();

const {users} = storeToRefs(useMainStore());

const pictureSize = ref<number>(props.size || 70);
const user = ref<User>({} as User);

const color = computed<string>(() => {
  const firstName = props.firstName || user.value.first_name;
  const lastName = props.lastName || user.value.last_name;

  return stringToColor(firstName + lastName);
});
const computedPictureUrl = computed<string>(
  () => props.pictureUrl || user.value.avatar_url,
);
const initials = computed<string>(() => {
  const {first_name, last_name} = user.value;

  if (first_name && last_name) {
    return `${first_name.charAt(0).toUpperCase()}.${last_name
      .charAt(0)
      .toUpperCase()}`;
  } else if (props.firstName && props.lastName)
    return props.firstName.charAt(0) + props.lastName.charAt(0);

  return "";
});

onMounted(() => {
  if (!props.userId) return;

  const currentUser = users.value.find((user) => user.id === props.userId);

  if (!currentUser) return;

  user.value = currentUser;
});
</script>

<template>
  <v-avatar :size="pictureSize" :color="color" class="justify-center">
    <v-img v-if="computedPictureUrl" :src="computedPictureUrl" cover></v-img>
    <span v-else class="text-blanc">
      {{ initials }}
    </span>
  </v-avatar>
</template>
